module.exports = __webpack_public_path__ + "img/diqui.1d0ca2c7.gif";